import {useScreenQuery} from '../../data/screen-details';
import {APP_URL} from 'components/config/Common'
import {Links} from '../../routes/PathLink'
import { Link} from "react-router-dom";

const RelatedScreens = () => {
    const {
        product:screenProduct,
    } = useScreenQuery({         
        limit: 10,
    });

    return (
        <>
        {screenProduct?.length > 0 && <section className="bg-white shadow-sm rounded-xl p-5">
            <h2 className="text-2xl">Related Stock Screens</h2>
            <div className="bg-white shadow-sm rounded-xl py-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {screenProduct?.map((val, key) => (
                    <div className="border rounded p-3 hover:shadow-lg transition-shadow duration-300">
                        <Link to={`${APP_URL}${Links.SCREENS}/${val.slug}`}>
                        <h2 className="text-heading text-lg text-gray-500 truncate">{val.title}</h2>
                        <div className="text-gray-500 truncate" dangerouslySetInnerHTML={{__html: val.description || ''}}></div>
                        </Link>
                    </div>
                ))
                }
                </div>
            </div>
            </section>
        }
        </>
    )
}
export default RelatedScreens;